import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs';
import { ApiResponse } from '@pharvio/core/shared';

export const responseInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    map((event) => {
      if (!(event instanceof HttpResponse)) return event;

      const body = event.body as ApiResponse<unknown> | null;
      if (body == null) return event;

      if (body.success === true) {
        return event.clone({ body: body.result });
      }

      if (body.success === false) {
        throw body.error;
      }

      // Non-Pharvios response (e.g. 204, external endpoint) — pass through
      return event;
    })
  );
};
